var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "access_time"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.9915 1.66748C5.3915 1.66748 1.6665 5.40081 1.6665 10.0008C1.6665 14.6008 5.3915 18.3341 9.9915 18.3341C14.5998 18.3341 18.3332 14.6008 18.3332 10.0008C18.3332 5.40081 14.5998 1.66748 9.9915 1.66748ZM9.99984 16.6675C6.3165 16.6675 3.33317 13.6841 3.33317 10.0008C3.33317 6.31748 6.3165 3.33415 9.99984 3.33415C13.6832 3.33415 16.6665 6.31748 16.6665 10.0008C16.6665 13.6841 13.6832 16.6675 9.99984 16.6675ZM10.4165 5.83415H9.1665V10.8341L13.5415 13.4591L14.1665 12.4341L10.4165 10.2091V5.83415Z",
    fill: "#8993A4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessTime);
export default __webpack_public_path__ + "static/media/access-time.8988e2ea3974acc438375cb8f1c94b60.svg";
export { ForwardRef as ReactComponent };